import Skeleton from '@mui/material/Skeleton';
import classNames from 'classnames';
import { ReactElement } from 'react';

import styles from './PlanEngagement.module.scss';

const EngagementSkeleton = (): ReactElement => (
  <div role="status" aria-label="Loading month" aria-busy className={styles.content}>
    <div className={styles.block}>
      <div className={styles.blockHeader}>
        <Skeleton width={120} className={styles.blockTitle} />
        <Skeleton width={200} className={styles.period} />
      </div>
      <div className={styles.progressRows}>
        {['hours', 'dollars'].map(row => (
          <div key={row} className={styles.skeletonProgressRow}>
            <Skeleton width={110} className={styles.skeletonProgressLabel} />
            <Skeleton variant="rounded" height={12} />
          </div>
        ))}
      </div>
    </div>
    <hr className={styles.divider} />
    <div className={classNames(styles.block, styles.entries)}>
      <Skeleton width={60} className={styles.blockTitle} />
      <div>
        {[1, 2].map(row => (
          <div key={row} className={styles.entry}>
            <div className={styles.entrySummary}>
              <Skeleton width={120} className={styles.entryAmount} />
              <Skeleton width={90} className={styles.entryReported} />
            </div>
            <div className={styles.entryDocuments}>
              <Skeleton width="60%" className={styles.skeletonDocument} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default EngagementSkeleton;
